import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import {
  productPriceClick,
  productClickOutBounce,
} from '../../actions/product';
import { AppState } from '../../../../reducers';
import { PriceListProps, PriceListStateProps } from './types';
import { PriceListPanel } from './price-list-panel';
import { PriceListPanelWrapper } from './styles';

const PriceList: React.FC<PriceListProps> = props => {
  const {
    productId,
    category,
    me,
    prices,
    variantGroups,
    conditions,
    ...priceListPanelProps
  } = props;

  const { market } = useContext(AppContext);
  return (
    <PriceListPanelWrapper>
      <PriceListPanel
        category={category}
        conditions={conditions}
        me={me}
        prices={prices}
        productId={productId}
        showProductInformationTexts={market.showProductInformationTexts}
        storeStatistics={prices?.meta?.storeStatistics}
        variantGroups={variantGroups}
        {...priceListPanelProps}
      />
    </PriceListPanelWrapper>
  );
};

const mapStateToProps = (state: AppState): PriceListStateProps => ({
  me: state.areas.account.me,
  priceDisplay: state.areas.product.priceDisplay,
  currentSorting: state.areas.product.sorting,
});

const dispatchProps = {
  dispatchProductPriceClick: productPriceClick,
  dispatchProductClickOutBounce: productClickOutBounce,
};

export default connect(mapStateToProps, dispatchProps)(PriceList);
